import {createRouter, createWebHistory} from 'vue-router';
import LandingView from '@/Pages/LandingView.vue';
import LoginView from "@/Pages/Auth/LoginView.vue";
import {useAuthStore} from "@/stores/auth.js";
import AuthenticatedLayout from "@/Layouts/AuthenticatedLayout.vue";
import HomeView from "@/Pages/HomeView.vue";
import ReportsView from "@/Pages/Reports/ReportsView.vue";
import AssetsLayout from "@/Layouts/AssetsLayout.vue";
import ManufacturersLayout from "@/Layouts/ManufacturersLayout.vue";
import AssetsDashboard from "@/Pages/Assets/AssetsDashboard.vue";
import AssetsIndexView from "@/Pages/Assets/AssetsIndexView.vue";
import AssetsRecentlyViewedView from "@/Pages/Assets/AssetsRecentlyViewedView.vue";
import DevicesDashboard from "@/Pages/Devices/DevicesDashboard.vue";
import DeviceModelView from "@/Pages/Admin/Devices/DeviceModels/DeviceModel/DeviceModelView.vue";
import DevicesIndexView from "@/Pages/Devices/DevicesIndexView.vue";
import DevicesRecentlyViewedView from "@/Pages/Devices/DevicesRecentlyViewedView.vue";
import DevicesLayout from "@/Layouts/DevicesLayout.vue";
import DevicesAdminLayout from "@/Pages/Admin/Devices/DevicesAdminLayout.vue";
import DeviceHistoryView from "@/Pages/Devices/Device/History/DeviceHistoryView.vue";
import DevicesIndex from "@/Pages/Admin/Devices/Devices/DevicesIndex.vue";
import DeviceView from "@/Pages/Devices/Device/DeviceView.vue";
import DeviceSummary from "@/Pages/Devices/Device/Summary/DeviceSummary.vue";
import AdminDevicePropertiesView from "@/Pages/Admin/Devices/Devices/Device/Properties/DevicePropertiesView.vue";
import DeviceAdminView from "@/Pages/Admin/Devices/Devices/Device/DeviceAdminView.vue";
import DeviceAssetsView from "@/Pages/Admin/Devices/Devices/Device/Assets/DeviceAssetsView.vue";
import DeviceModelsIndex from "@/Pages/Admin/Devices/DeviceModels/DeviceModelsIndex.vue";
import DeviceModelPropertiesView
    from '@/Pages/Admin/Devices/DeviceModels/DeviceModel/Properties/DeviceModelPropertiesView.vue';
import DeviceRevisionsIndex from '@/Pages/Admin/Devices/Revisions/DeviceRevisionsIndex.vue';
import DeviceRevisionView from '@/Pages/Admin/Devices/Revisions/Revision/DeviceRevisionView.vue';
import DeviceRevisionPropertiesView
    from '@/Pages/Admin/Devices/Revisions/Revision/Properties/DeviceRevisionPropertiesView.vue';
import FirmwareAdminLayout from '@/Pages/Admin/Firmware/FirmwareAdminLayout.vue';
import FirmwareIndex from '@/Pages/Admin/Firmware/Firmware/FirmwareIndex.vue';
import FirmwareView from '@/Pages/Admin/Firmware/Firmware/Firmware/FirmwareView.vue';
import FirmwarePropertiesView from '@/Pages/Admin/Firmware/Firmware/Firmware/Properties/FirmwarePropertiesView.vue';
import FirmwareTypesIndex from '@/Pages/Admin/Firmware/Types/FirmwareTypesIndex.vue';
import FirmwareTypeView from '@/Pages/Admin/Firmware/Types/Type/FirmwareTypeView.vue';
import FirmwareTypePropertiesView from '@/Pages/Admin/Firmware/Types/Type/Properties/FirmwareTypePropertiesView.vue';
import FirmwareBulkGenerateView from '@/Pages/Admin/Firmware/Bulk/FirmwareBulkGenerateView.vue';
import FirmwareReleaseNotesView
    from '@/Pages/Admin/Firmware/Firmware/Firmware/ReleaseNotes/FirmwareReleaseNotesView.vue';
import FirmwareTestingDocumentsView
    from '@/Pages/Admin/Firmware/Firmware/Firmware/TestingDocuments/FirmwareTestingDocumentsView.vue';
import ForbiddenView from '@/Pages/Errors/ForbiddenView.vue';
import UsersAdminLayout from '@/Pages/Admin/Users/UsersAdminLayout.vue';
import UsersIndex from '@/Pages/Admin/Users/Users/UsersIndex.vue';
import UserView from '@/Pages/Admin/Users/Users/User/UserView.vue';
import UserPropertiesView from '@/Pages/Admin/Users/Users/User/Properties/UserPropertiesView.vue';
import RolesIndex from '@/Pages/Admin/Users/Roles/RolesIndex.vue';
import RoleView from '@/Pages/Admin/Users/Roles/Role/RoleView.vue';
import RolePropertiesView from '@/Pages/Admin/Users/Roles/Role/Properties/RolePropertiesView.vue';
import PermissionsIndex from '@/Pages/Admin/Users/Permissions/PermissionsIndex.vue';
import PermissionView from '@/Pages/Admin/Users/Permissions/Permission/PermissionView.vue';
import PermissionPropertiesView
    from '@/Pages/Admin/Users/Permissions/Permission/Properties/PermissionPropertiesView.vue';
import RolePermissionsView from '@/Pages/Admin/Users/Roles/Role/Permissions/RolePermissionsView.vue';
import UserRolesView from '@/Pages/Admin/Users/Users/User/Roles/UserRolesView.vue';
import TeamsIndex from '@/Pages/Admin/Users/Teams/TeamsIndex.vue';
import TeamView from '@/Pages/Admin/Users/Teams/Team/TeamView.vue';
import TeamPropertiesView from '@/Pages/Admin/Users/Teams/Team/Properties/TeamPropertiesView.vue';
import ForgotPasswordView from '@/Pages/Auth/ForgotPasswordView.vue';
import ResetPasswordView from '@/Pages/Auth/ResetPasswordView.vue';
import FirmwareHistoryView from "@/Pages/Admin/Firmware/Firmware/Firmware/History/FirmwareHistoryView.vue";
import AdminDeviceHistoryView from "@/Pages/Admin/Devices/Devices/Device/History/DeviceHistoryView.vue";
import AssetView from "@/Pages/Assets/Asset/AssetView.vue";
import AssetSummaryView from "@/Pages/Assets/Asset/Summary/AssetSummaryView.vue";
import AssetHistoryView from "@/Pages/Assets/Asset/History/AssetHistoryView.vue";
import AssetPropertiesView from "@/Pages/Assets/Asset/Properties/AssetPropertiesView.vue";
import DevicePropertiesView from "@/Pages/Devices/Device/Properties/DevicePropertiesView.vue";
import DeviceTypesIndex from "@/Pages/Admin/Devices/DeviceTypes/DeviceTypesIndex.vue";
import DeviceTypeView from "@/Pages/Admin/Devices/DeviceTypes/DeviceType/DeviceTypeView.vue";
import DeviceTypePropertiesView
    from "@/Pages/Admin/Devices/DeviceTypes/DeviceType/Properties/DeviceTypePropertiesView.vue";
import DeviceManufacturersIndex from "@/Pages/Admin/Devices/DeviceManufacturers/DeviceManufacturersIndex.vue";
import DeviceManufacturerView
    from "@/Pages/Admin/Devices/DeviceManufacturers/DeviceManufacturer/DeviceManufacturerView.vue";
import DeviceManufacturerPropertiesView
    from "@/Pages/Admin/Devices/DeviceManufacturers/DeviceManufacturer/Properties/DeviceManufacturerPropertiesView.vue";
import UserCompaniesView from "@/Pages/Admin/Users/Users/User/Companies/UserCompaniesView.vue";
import CompaniesAdminLayout from "@/Pages/Admin/Companies/CompaniesAdminLayout.vue";
import CompaniesIndex from "@/Pages/Admin/Companies/Companies/CompaniesIndex.vue";
import CompanyAdminView from "@/Pages/Admin/Companies/Companies/Company/CompanyAdminView.vue";
import CompanyPropertiesView from "@/Pages/Admin/Companies/Companies/Company/Properties/CompanyPropertiesView.vue";
import CompanyHistoryView from "@/Pages/Admin/Companies/Companies/Company/History/CompanyHistoryView.vue";
import CompanyRelationshipsIndex from "@/Pages/Admin/Companies/Relationships/CompanyRelationshipsIndex.vue";
import CompanyRelationshipAdminView from "@/Pages/Admin/Companies/Relationships/Relationship/CompanyRelationshipAdminView.vue";
import CompanyRelationshipPropertiesView from "@/Pages/Admin/Companies/Relationships/Relationship/Properties/CompanyRelationshipPropertiesView.vue";
import RegulationAdminLayout from "@/Pages/Admin/Regulations/RegulationAdminLayout.vue";
import RegulationPropertiesView
    from "@/Pages/Admin/Regulations/Regulations/Regulation/Properties/RegulationPropertiesView.vue";
import RegulationsIndex from "@/Pages/Admin/Regulations/Regulations/RegulationsIndex.vue";
import RegulationAdminView from "@/Pages/Admin/Regulations/Regulations/Regulation/RegulationAdminView.vue";
import RegulationHistoryView from "@/Pages/Admin/Regulations/Regulations/Regulation/History/RegulationHistoryView.vue";
import FirmwareRegulationsView from "@/Pages/Admin/Firmware/Firmware/Firmware/Regulations/FirmwareRegulationsView.vue";
import DeviceRevisionRegulationsView
    from "@/Pages/Admin/Devices/Revisions/Revision/Regulations/DeviceRevisionRegulationsView.vue";
import ThirdPartyFirmwareIndex from '@/Pages/Admin/Devices/FirmwareUpload/ThirdPartyFirmwareIndex.vue';
import DeviceThirdPartyFirmwareView from '@/Pages/Admin/Devices/FirmwareUpload/Firmware/DeviceThirdPartyFirmwareView.vue';
import DeviceThirdPartyFirmwarePropertiesView from '@/Pages/Admin/Devices/FirmwareUpload/Firmware/Properties/DeviceThirdPartyFirmwarePropertiesView.vue';
import DeviceRevisionHistoryView from "@/Pages/Admin/Devices/Revisions/Revision/History/DeviceRevisionHistoryView.vue";
import ManufacturersFirmwareUpdateDashboardView
    from "@/Pages/Manufacturers/Dashboard/ManufacturersFirmwareUpdateDashboardView.vue";
import ManufacturersFirmwareDeviceOverridesView 
	from "@/Pages/Manufacturers/Overrides/ManufacturersFirmwareDeviceOverridesView.vue";
import AssetsAdminLayout from "@/Pages/Admin/Assets/AssetsAdminLayout.vue";
import AssetsIndex from "@/Pages/Admin/Assets/Assets/AssetsIndex.vue";
import AssetAdminView from "@/Pages/Admin/Assets/Assets/Asset/AssetAdminView.vue";
import AdminAssetPropertiesView from "@/Pages/Admin/Assets/Assets/Asset/Properties/AssetPropertiesView.vue";
import AssetDeviceView from "@/Pages/Admin/Assets/Assets/Asset/Devices/AssetDevicesView.vue";
import AssetTransferOwnershipView from "@/Pages/Admin/Assets/Assets/Asset/TransferOwnership/AssetTransferOwnershipView.vue";
import AssetTypesIndex from "@/Pages/Admin/Assets/AssetTypes/AssetTypesIndex.vue";
import AssetTypeView from "@/Pages/Admin/Assets/AssetTypes/AssetType/AssetTypeView.vue";
import AssetTypePropertiesView from "@/Pages/Admin/Assets/AssetTypes/AssetType/Properties/AssetTypePropertiesView.vue";
import AssetTransfersIndex from "@/Pages/Admin/Assets/AssetTransfers/AssetTransfersIndex.vue";
import AssetTransferView from "@/Pages/Admin/Assets/AssetTransfers/AssetTransfer/AssetTransferView.vue";
import AssetTransferPropertiesView
    from "@/Pages/Admin/Assets/AssetTransfers/AssetTransfer/Properties/AssetTransferPropertiesView.vue";
import DeviceImportsIndex from "@/Pages/Admin/Devices/DeviceImport/DeviceImportsIndex.vue";
import DiagPlusPlusView from "@/Pages/DiagPlusPlusView.vue";
import RxSwinSearch from "@/Pages/RxSwinSearch/RxSwinSearch.vue";
import RxSwinSearchOverview from "@/Pages/RxSwinSearch/Overview/RxSwinSearchOverview.vue";
import FirmwareLayout from "@/Layouts/FirmwareLayout.vue";
import FirmwareOverviewView from "@/Pages/Firmware/FirmwareOverviewView.vue";
import EndOfLineTestingDocumentsView
    from "@/Pages/Admin/Devices/Devices/Device/EndOfLineTestingDocuments/EndOfLineTestingDocumentsView.vue";
import R156InformationView from "@/Pages/R156InformationView.vue";
import ConfigRequestsIndex from "@/Pages/Admin/ConfigRequests/ConfigRequestsIndex.vue";
import ConfigRequestShow from "@/Pages/Admin/ConfigRequests/ConfigRequestShow.vue";
import NewRolesView from "@/Pages/NewRolesView.vue";
import NewRolesCsvUploadView from "@/Pages/NewRolesCsvUploadView.vue";
import ApiLogsIndex from '@/Pages/Admin/ApiLogs/ApiLogsIndex.vue';
import ConfigUnlockCreate from "@/Pages/Admin/ConfigUnlockCreate.vue";


const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'landing',
            // redirect: {name: 'login'},
            component: LandingView,
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                middleware: 'guest',
            },
            component: LoginView,
        },
        {
            path: '/forgot-password',
            name: 'password.request',
            meta: {
                middleware: 'guest',
            },
            component: ForgotPasswordView,
        },
        {
            path: '/reset-password/:token',
            name: 'password.reset',
            meta: {
                middleware: 'guest',
            },
            component: ResetPasswordView,
        },
        {
            path: '/errors/forbidden',
            name: 'errors.forbidden',
            meta: {
                middleware: 'auth',
            },
            component: ForbiddenView,
        },
        {
            path: '/',
            component: AuthenticatedLayout,
            meta: {
                middleware: 'auth',
            },
            children: [
                {
                    path: 'manufacturers',
                    name: 'manufacturers',
                    component: ManufacturersLayout,
                    children: [
                        {
                            path: ':manufacturer/revisions/:revision/dashboard',
                            name: 'manufacturers.dashboard',
                            component: ManufacturersFirmwareUpdateDashboardView,
                        },
                        {
                            path: ':manufacturer/revisions/:revision/overrides',
                            name: 'manufacturers.overrides',
                            component: ManufacturersFirmwareDeviceOverridesView,
                        },
                    ]
                },
                {
                    path: 'rx-swin-search',
                    name: 'rxswin.search',
                    component: RxSwinSearch,
                    meta: {
                        middleware: 'read:rx-swins',
                    },
                },
                {
                    path: 'rx-swin-search/:rxswin/overview',
                    name: 'rxswin.search.overview',
                    component: RxSwinSearchOverview,
                    meta: {
                        middleware: 'read:rx-swins',
                    },
                },
                // import devices
                {
                    path: 'device-import',
                    name: 'admin.devices.import',
                    meta: {
                        middleware: 'create:imports'
                    },
                    component: DeviceImportsIndex,
                },
                { // not-admin
                    path: 'firmware-lookup',
                    name: 'firmware',
                    component: FirmwareLayout,
                    meta: {
                        middleware: 'read:firmwares',
                    },
                    children: [
                        {
                            path: 'revision/:revision',
                            name: 'firmware.overview',
                            component: FirmwareOverviewView,
                        },
                    ]
                },
                {
                    path: 'home',
                    name: 'home',
                    component: HomeView,
                },
                {
                    path: 'new-roles',
                    name: 'new-roles',
                    component: NewRolesView,
                },
                {
                    path: 'new-roles-csv-upload',
                    name: 'new-roles-csv-upload',
                    component: NewRolesCsvUploadView,
                },
                {
                    path: 'diag-plus-plus',
                    name: 'diag-plus-plus',
                    component: DiagPlusPlusView,
                    meta: {
                        middleware: 'download:diag-plus-plus',
                    },
                },
                {
                    path: 'r156-information',
                    name: 'r156-information',
                    component: R156InformationView,
                },
                {
                    path: 'reports',
                    name: 'reports',
                    component: ReportsView,
                    meta: {
                        middleware: 'read:reports',
                    },
                },
                {
                    path: 'assets',
                    component: AssetsLayout,
                    meta: {
                        middleware: 'read:assets',
                    },
                    children: [
                        {
                            path: 'overview',
                            name: 'assets',
                            alias: [''],
                            component: AssetsDashboard,
                        },
                        {
                            path: 'index',
                            name: 'assets.index',
                            component: AssetsIndexView,
                        },
                        {
                            path: 'recently-viewed',
                            name: 'assets.recently-viewed',
                            component: AssetsRecentlyViewedView,
                        },
                    ],
                },
                {
                    path: 'assets/show/:asset',
                    component: AssetView,
                    meta: {
                        middleware: 'read:assets',
                    },
                    children: [
                        {
                            path: 'summary',
                            name: 'assets.show',
                            alias: [''],
                            component: AssetSummaryView,
                        },
                        {
                            path: 'properties',
                            name: 'assets.show.properties',
                            component: AssetPropertiesView,
                        },
                        {
                            path: 'history',
                            name: 'assets.show.history',
                            component: AssetHistoryView,
                        },
                    ]
                },
                {
                    path: 'devices',
                    component: DevicesLayout,
                    meta: {
                        middleware: 'read:devices',
                    },
                    children: [
                        {
                            path: 'overview',
                            name: 'devices',
                            alias: [''],
                            component: DevicesDashboard,
                        },
                        {
                            path: 'index',
                            name: 'devices.index',
                            component: DevicesIndexView,
                        },
                        {
                            path: 'recently-viewed',
                            name: 'devices.recently-viewed',
                            component: DevicesRecentlyViewedView,
                        },
                    ],
                },
                {
                    path: 'devices/:device',
                    meta: {
                        middleware: 'read:devices',
                    },
                    component: DeviceView,
                    children: [
                        {
                            path: 'summary',
                            name: 'devices.show',
                            alias: [''],
                            component: DeviceSummary
                        },
                        {
                            path: 'properties',
                            name: 'devices.show.properties',
                            component: DevicePropertiesView
                        },
                        {
                            path: 'history',
                            name: 'devices.show.history',
                            component: DeviceHistoryView
                        },
                    ]
                },
            ]
        },
        {
            path: '/admin',
            component: AuthenticatedLayout,
            meta: {
                middleware: 'auth',
            },
            children: [
                {
                    // header, and the tabs under the devices section
                    path: 'assets',
                    component: AssetsAdminLayout,
                    children: [
                        // Tab: Assets
                        {
                            path: '',
                            name: 'admin.assets',
                            meta: {
                                middleware: 'create:assets|update:assets'
                            },
                            component: AssetsIndex,
                            children: [
                                {
                                    path: ':asset?',
                                    component: AssetAdminView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.assets.asset',
                                            component: AdminAssetPropertiesView
                                        },
                                        {
                                            path: 'devices',
                                            name: 'admin.assets.asset.devices',
                                            component: AssetDeviceView
                                        },
                                        {
                                            path: 'transfer_ownership',
                                            name: 'admin.assets.asset.transfer_ownership',
                                            component: AssetTransferOwnershipView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.assets.asset.history',
                                            component: AssetHistoryView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Types
                        {
                            path: 'types',
                            name: 'admin.assets.types',
                            meta: {
                                middleware: 'create:asset-types|update:asset-types'
                            },
                            component: AssetTypesIndex,
                            children: [
                                {
                                    path: ':type?',
                                    component: AssetTypeView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.assets.types.type',
                                            component: AssetTypePropertiesView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Transfers
                        {
                            path: 'transfers',
                            name: 'admin.assets.transfers',
                            meta: {
                                middleware: 'create:asset-transfers|read:asset-transfers'
                            },
                            component: AssetTransfersIndex,
                            children: [
                                {
                                    path: ':transfer?',
                                    component: AssetTransferView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.assets.transfers.transfer',
                                            component: AssetTransferPropertiesView
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    // header, and the tabs under the devices section
                    path: 'companies',
                    component: CompaniesAdminLayout,
                    children: [
                        // Tab: Companies
                        {
                            path: '',
                            name: 'admin.companies',
                            meta: {
                                middleware: 'create:companies|update:companies'
                            },
                            component: CompaniesIndex,
                            children: [
                                {
                                    path: ':company?',
                                    component: CompanyAdminView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.companies.company',
                                            component: CompanyPropertiesView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.companies.company.history',
                                            component: CompanyHistoryView
                                        },
                                    ]
                                },
                            ]
                        },
                        // Tab: Company Relationships
                        {
                            path: 'relationships',
                            name: 'admin.companies.relationships',
                            meta: {
                                middleware: 'create:company-relationships|read:company-relationships'
                            },
                            component: CompanyRelationshipsIndex,
                            children: [
                                {
                                    path: ':relationship?',
                                    component: CompanyRelationshipAdminView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.companies.relationships.relationship',
                                            component: CompanyRelationshipPropertiesView,
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    // header, and the tabs under the devices section
                    path: 'devices',
                    component: DevicesAdminLayout,
                    children: [
                        // Tab: Devices
                        {
                            path: '',
                            name: 'admin.devices',
                            meta: {
                                middleware: 'create:devices|update:devices'
                            },
                            component: DevicesIndex,
                            children: [
                                {
                                    path: ':device?',
                                    component: DeviceAdminView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.device',
                                            component: AdminDevicePropertiesView
                                        },
                                        {
                                            path: 'assets',
                                            name: 'admin.devices.device.assets',
                                            component: DeviceAssetsView
                                        },
                                        {
                                            path: 'end-of-line-testing-documents',
                                            name: 'admin.devices.device.end-of-line-testing-documents',
                                            component: EndOfLineTestingDocumentsView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.devices.device.history',
                                            component: AdminDeviceHistoryView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Manufacturers
                        {
                            path: 'manufacturers',
                            name: 'admin.devices.manufacturers',
                            meta: {
                                middleware: 'create:device-manufacturers|update:device-manufacturers'
                            },
                            component: DeviceManufacturersIndex,
                            children: [
                                {
                                    path: ':manufacturer?',
                                    component: DeviceManufacturerView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.manufacturers.manufacturer',
                                            component: DeviceManufacturerPropertiesView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Models
                        {
                            path: 'models',
                            name: 'admin.devices.models',
                            meta: {
                                middleware: 'create:device-models|update:device-models'
                            },
                            component: DeviceModelsIndex,
                            children: [
                                {
                                    path: ':model?',
                                    component: DeviceModelView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.models.model',
                                            component: DeviceModelPropertiesView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Revisions
                        {
                            path: 'revisions',
                            name: 'admin.devices.revisions',
                            meta: {
                                middleware: 'create:device-revisions|update:device-revisions'
                            },
                            component: DeviceRevisionsIndex,
                            children: [
                                {
                                    path: ':revision?',
                                    component: DeviceRevisionView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.revisions.revision',
                                            component: DeviceRevisionPropertiesView
                                        },
                                        {
                                            path: 'regulations',
                                            name: 'admin.devices.revisions.revision.regulations',
                                            component: DeviceRevisionRegulationsView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.devices.revisions.revision.history',
                                            component: DeviceRevisionHistoryView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Third Party Firmware
                        {
                            path: 'third-party-firmwares',
                            name: 'admin.devices.third-party-firmwares',
                            meta: {
                                middleware: 'create:device-third-party-firmwares|update:device-third-party-firmwares'
                            },
                            component: ThirdPartyFirmwareIndex,
                            children: [
                                {
                                    path: ':firmware?',
                                    component: DeviceThirdPartyFirmwareView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.third-party-firmwares.firmware',
                                            redirect: to => ({ name: 'admin.devices.third-party-firmwares.firmware.properties', params: to.params }),
                                        },
                                        {
                                            path: 'properties',
                                            name: 'admin.devices.third-party-firmwares.firmware.properties',
                                            component: DeviceThirdPartyFirmwarePropertiesView,
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Types
                        {
                            path: 'types',
                            name: 'admin.devices.types',
                            meta: {
                                middleware: 'create:device-types|update:device-types'
                            },
                            component: DeviceTypesIndex,
                            children: [
                                {
                                    path: ':type?',
                                    component: DeviceTypeView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.devices.types.type',
                                            component: DeviceTypePropertiesView
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'firmware',
                    component: FirmwareAdminLayout,
                    children: [
                        // Tab: Firmwares
                        {
                            path: '',
                            name: 'admin.firmware',
                            meta: {
                                middleware: 'create:firmwares|update:firmwares'
                            },
                            component: FirmwareIndex,
                            children: [
                                {
                                    path: ':firmware?',
                                    component: FirmwareView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.firmware.firmware',
                                            component: FirmwarePropertiesView
                                        },
                                        {
                                            path: 'release-notes',
                                            name: 'admin.firmware.firmware.release-notes',
                                            component: FirmwareReleaseNotesView
                                        },
                                        {
                                            path: 'testing-documents',
                                            name: 'admin.firmware.firmware.testing-documents',
                                            component: FirmwareTestingDocumentsView
                                        },
                                        {
                                            path: 'regulations',
                                            name: 'admin.firmware.firmware.regulations',
                                            component: FirmwareRegulationsView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.firmware.firmware.history',
                                            component: FirmwareHistoryView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Firmware Types
                        {
                            path: 'types',
                            name: 'admin.firmware.types',
                            meta: {
                                middleware: 'create:firmware-types|update:firmware-types'
                            },
                            component: FirmwareTypesIndex,
                            children: [
                                {
                                    path: ':firmwareType?',
                                    component: FirmwareTypeView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.firmware.types.type',
                                            component: FirmwareTypePropertiesView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Bulk Generate (non-production only)
                        {
                            path: 'bulk',
                            name: 'admin.firmware.bulk',
                            meta: {
                                middleware: 'create:firmwares'
                            },
                            component: FirmwareBulkGenerateView,
                        },
                    ]
                },
                {
                    // header, and the tabs under the devices section
                    path: 'regulations',
                    component: RegulationAdminLayout,
                    children: [
                        // Tab: Regulations
                        {
                            path: '',
                            name: 'admin.regulations',
                            meta: {
                                middleware: 'create:regulations|update:regulations'
                            },
                            component: RegulationsIndex,
                            children: [
                                {
                                    path: ':regulation?',
                                    component: RegulationAdminView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.regulations.regulation',
                                            component: RegulationPropertiesView
                                        },
                                        {
                                            path: 'history',
                                            name: 'admin.regulations.regulation.history',
                                            component: RegulationHistoryView
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'api-logs',
                    name: 'admin.api-logs',
                    meta: {
                        middleware: 'read:api-logs'
                    },
                    component: ApiLogsIndex,
                },
                {
                    path: 'config-requests',
                    name: 'admin.config-requests',
                    meta: {
                        middleware: 'read:config-change-request'
                    },
                    component: ConfigRequestsIndex,
                },
                {
                    path: 'config-requests/:id',
                    name: 'admin.config-requests.show',
                    meta: {
                        middleware: 'read:config-change-request'
                    },
                    component: ConfigRequestShow,
                },
                {
                    path: 'config-requests/create',
                    name: 'admin.config-requests.create',
                    component: ConfigUnlockCreate,
                },
                {
                    path: 'users',
                    component: UsersAdminLayout,
                    children: [
                        // Tab: Users
                        {
                            path: '',
                            name: 'admin.users',
                            meta: {
                                middleware: 'create:users|update:users'
                            },
                            component: UsersIndex,
                            children: [
                                {
                                    path: ':user?',
                                    component: UserView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.users.user',
                                            component: UserPropertiesView
                                        },
                                        {
                                            path: 'roles',
                                            name: 'admin.users.user.roles',
                                            component: UserRolesView
                                        },
                                        {
                                            path: 'companies',
                                            name: 'admin.users.user.companies',
                                            component: UserCompaniesView
                                        }
                                    ]
                                },
                            ]
                        },

                        // Tab: Roles
                        {
                            path: 'roles',
                            name: 'admin.users.roles',
                            meta: {
                                middleware: 'create:roles|update:roles'
                            },
                            component: RolesIndex,
                            children: [
                                {
                                    path: ':role?',
                                    component: RoleView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.users.roles.role',
                                            component: RolePropertiesView
                                        },
                                        {
                                            path: 'permissions',
                                            name: 'admin.users.roles.role.permissions',
                                            component: RolePermissionsView
                                        }
                                    ]
                                },
                            ]
                        },

                        // Tab: Permissions
                        {
                            path: 'permissions',
                            name: 'admin.users.permissions',
                            meta: {
                                middleware: 'create:permissions|update:permissions'
                            },
                            component: PermissionsIndex,
                            children: [
                                {
                                    path: ':permission?',
                                    component: PermissionView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.users.permissions.permission',
                                            component: PermissionPropertiesView
                                        },
                                    ]
                                },
                            ]
                        },

                        // Tab: Teams
                        {
                            path: 'teams',
                            name: 'admin.users.teams',
                            meta: {
                                middleware: 'create:teams|update:teams'
                            },
                            component: TeamsIndex,
                            children: [
                                {
                                    path: ':team?',
                                    component: TeamView,
                                    children: [
                                        {
                                            path: '',
                                            name: 'admin.users.teams.team',
                                            component: TeamPropertiesView
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
            ]
        },
    ]
})

router.beforeEach((to, from) => {
    const auth = useAuthStore();

    // if not middleware has been declared for the route, continue as expected
    if (!to.meta?.middleware) {
        return true;
    }

    const middlewares = to.meta?.middleware.split('|');

    // if the route should only be available to authenticated users, and the user
    // is NOT logged in, redirect to the login page
    if (middlewares.includes('auth') && !auth.isLoggedIn) {
        return {name: 'login'}
    }

    // if the route should only be available to unauthenticated users, and the user
    // is logged in, then redirect to their dashboard
    if (middlewares.includes('guest') && auth.isLoggedIn) {
        return {name: 'home'}
    }

    if (middlewares.length === 1 && (middlewares.includes('auth') || middlewares.includes('guest'))) {
        return true;
    }

    // If user does not have 'some' of the relevant permissions needed to view this route
    // then prevent navigation
    if (!middlewares.some(r => auth.hasPermission(r))) {
        console.error(`User does not have any of the required permissions to visit ${to.path}`, middlewares);
        return {name: 'errors.forbidden', query: {intended: to.path}}
    }

    return true;
    // return false;
})

export default router
